module.exports = __webpack_public_path__ + "img/Offline-Mode.8c5a3b72.svg";